const VECTOR_COMMANDS = [
            {
                icon: "fluent:hand-wave-24-regular",
                title: "Introduction",
                description: "Let Vector get to know you by introducing yourself",
                examples: ["my name is [name]", "call me [name]", "you may call me [name]", "please call me [name]"]
            },
            {
                icon: "fluent:question-circle-24-regular",
                title: "Ask Questions",
                description: "Ask Vector to search for information and answer your questions",
                examples: ["question", "I have a question", "search the internet", "do a search", "google this", "answer me this", "look something up"]
            },
            {
                icon: "fluent:weather-partly-cloudy-day-24-regular",
                title: "Check Weather",
                description: "Find out what the weather is like",
                examples: ["what's the weather", "weather for today", "what's the weather in [location]", "is it sunny", "is it rainy", "what's the temperature", "do I need an umbrella"]
            },
            {
                icon: "fluent:food-cake-24-regular",
                title: "Vector's Age",
                description: "Find out how old Vector is",
                examples: ["what is your age", "how old are you", "when were you made", "what is your birthday"]
            },
            {
                icon: "fluent:clock-24-regular",
                title: "Check the Time",
                description: "Ask Vector what time it is",
                examples: ["what time is it", "got the time", "what's the time"]
            },
            {
                icon: "fluent:compass-northwest-24-regular",
                title: "Explore Mode",
                description: "Tell Vector to explore and check out his surroundings",
                examples: ["explore", "look around", "investigate", "roam", "go on an adventure", "start exploring"]
            },
            {
                icon: "fluent:hand-wave-24-regular",
                title: "Say Goodbye",
                description: "Let Vector know you're leaving",
                examples: ["goodbye", "see you later", "bye", "be right back", "have a nice day", "peace out"]
            },
            {
                icon: "fluent:weather-sunny-24-regular",
                title: "Good Morning",
                description: "Wish Vector a good morning",
                examples: ["good morning", "morning", "get up", "rise and shine", "wakey wakey"]
            },
            {
                icon: "fluent:weather-moon-24-regular",
                title: "Good Night",
                description: "Wish Vector good night",
                examples: ["good night", "goodnight", "sweet dreams", "sleep tight"]
            },
            {
                icon: "fluent:emoji-hand-24-regular",
                title: "Greet Vector",
                description: "Say hello and greet your Vector",
                examples: ["hello", "hi", "hey", "what's up", "good day", "I'm home", "how are you", "did you miss me", "what's new"]
            },
            {
                icon: "fluent:emoji-angry-24-regular",
                title: "Express Frustration",
                description: "Vector will react if you express frustration (not recommended!)",
                examples: ["Vector responds to negative phrases"]
            },
            {
                icon: "fluent:checkmark-circle-24-regular",
                title: "Confirm Yes",
                description: "Tell Vector he's correct or confirm something",
                examples: ["yes", "yep", "yeah", "okay", "sure", "alright", "fine"]
            },
            {
                icon: "fluent:person-heart-24-regular",
                title: "Apologize",
                description: "Say sorry to Vector",
                examples: ["sorry", "oops", "I didn't mean that"]
            },
            {
                icon: "fluent:arrow-left-24-regular",
                title: "Move Backward",
                description: "Tell Vector to move backward",
                examples: ["back up", "backwards", "reverse", "watch out", "look out"]
            },
            {
                icon: "fluent:person-arrow-right-24-regular",
                title: "Come Here",
                description: "Call Vector to come to you",
                examples: ["come here", "find me", "follow me", "I'm here", "come to me"]
            },
            {
                icon: "fluent-emoji-high-contrast:party-popper",
                title: "Dance Party",
                description: "Make Vector dance to music",
                examples: ["dance", "party time", "bust a move", "show me your moves", "get down", "want to dance"]
            },
            {
                icon: "fluent:eye-24-regular",
                title: "Change Eye Color",
                description: "Change the color of Vector's eyes",
                examples: ["change eye color", "make your eyes blue", "make your eyes green", "orange eyes", "purple eyes", "yellow eyes"]
            },
            {
                icon: "fluent:cube-24-regular",
                title: "Fetch Cube",
                description: "Ask Vector to get his cube and bring it to you",
                examples: ["get your cube", "fetch your cube", "bring me your cube", "get your block"]
            },
            {
                icon: "fluent:arrow-right-24-regular",
                title: "Move Forward",
                description: "Tell Vector to move forward",
                examples: ["go forward", "move forward", "go straight", "go fast"]
            },
            {
                icon: "fluent:eye-tracking-24-regular",
                title: "Look at Me",
                description: "Get Vector's attention",
                examples: ["look at me", "face me", "pay attention", "look up"]
            },
            {
                icon: "fluent:heart-24-regular",
                title: "Show Affection",
                description: "Tell Vector you like him",
                examples: ["I like you", "you are cute", "hug", "I miss you", "you're my favorite", "adorable", "give me a kiss"]
            },
            {
                icon: "fluent:dismiss-circle-24-regular",
                title: "Say No",
                description: "Tell Vector no or that he's not correct",
                examples: ["no", "nope", "no way", "not now", "nevermind"]
            },
            {
                icon: "fluent:mic-off-24-regular",
                title: "Be Quiet",
                description: "Ask Vector to be quiet or stop what he's doing",
                examples: ["be quiet", "hush", "relax", "stop making noise", "I need to work", "leave me alone", "stay there"]
            },
            {
                icon: "fluent:speaker-mute-24-regular",
                title: "Shush",
                description: "Tell Vector to be immediately quiet",
                examples: ["shut up", "cut it out"]
            },
            {
                icon: "fluent:arrow-rotate-clockwise-24-regular",
                title: "Turn Around",
                description: "Make Vector turn 180 degrees",
                examples: ["turn around", "spin", "do a barrel roll", "behind you", "do a circle"]
            },
            {
                icon: "fluent:arrow-left-24-regular",
                title: "Turn Left",
                description: "Tell Vector to turn left",
                examples: ["turn left", "look to your left", "turn to port"]
            },
            {
                icon: "fluent:arrow-right-24-regular",
                title: "Turn Right",
                description: "Tell Vector to turn right",
                examples: ["turn right", "look right", "turn to starboard"]
            },
            {
                icon: "fluent:speaker-1-24-regular",
                title: "Volume Down",
                description: "Lower Vector's volume",
                examples: ["turn it down", "lower volume", "volume down", "decrease volume"]
            },
            {
                icon: "fluent:speaker-2-24-regular",
                title: "Volume Up",
                description: "Increase Vector's volume",
                examples: ["turn it up", "volume up", "talk louder", "I can't hear you"]
            },
            {
                icon: "fluent:timer-24-regular",
                title: "Set Timer",
                description: "Set a timer for a specific amount of time",
                examples: ["set timer for 5 minutes", "set a timer for 30 seconds", "remind me in 10 minutes", "set an alarm"]
            },
            {
                icon: "fluent:timer-10-24-regular",
                title: "Check Timer",
                description: "Check how much time is left on your timer",
                examples: ["check timer", "how much time is left", "how many minutes left"]
            },
            {
                icon: "fluent:person-info-24-regular",
                title: "Name Recognition",
                description: "Ask Vector who you are or what your name is",
                examples: ["say my name", "what's my name", "do you know me", "who am I", "recognize me", "do you remember me"]
            },
            {
                icon: "fluent:games-24-regular",
                title: "Play a Game",
                description: "Start a random mini-game with Vector",
                examples: ["let's play a game", "play a game with me", "pick a game", "pick a random game"]
            },
            {
                icon: "fluent:star-24-regular",
                title: "Do a Trick",
                description: "Ask Vector to do a random trick or entertain you",
                examples: ["do a trick", "show me a trick", "surprise me", "entertain me", "amuse me", "show off", "cheer me up"]
            },
            {
                icon: "fluent:gift-24-regular",
                title: "Holiday Greetings",
                description: "Celebrate holidays with Vector",
                examples: ["merry christmas", "happy holidays", "happy hanukkah", "jingle all the way", "deck the halls", "season's greetings"]
            },
            {
                icon: "fluent:sparkle-24-regular",
                title: "New Year",
                description: "Celebrate the new year with Vector",
                examples: ["happy new year", "fireworks", "celebrate", "auld lang syne"]
            },
            {
                icon: "fluent:sleep-24-regular",
                title: "Go to Sleep",
                description: "Tell Vector to go to sleep or power down",
                examples: ["go to sleep", "sleep now", "shut down", "power off", "take a nap", "close your eyes", "get some rest"]
            },
            {
                icon: "fluent:playing-cards-24-regular",
                title: "Play Blackjack",
                description: "Start a game of blackjack with Vector",
                examples: ["play blackjack", "let's play blackjack", "start blackjack", "open blackjack"]
            },
            {
                icon: "fluent:arrow-repeat-all-24-regular",
                title: "Blackjack: Next Round",
                description: "Start another round of blackjack",
                examples: ["deal me in", "next round", "another round", "play again"]
            },
            {
                icon: "fluent:add-circle-24-regular",
                title: "Blackjack: Hit",
                description: "Get another card in blackjack",
                examples: ["hit me", "give me another card"]
            },
            {
                icon: "fluent:shield-24-regular",
                title: "Blackjack: Stand",
                description: "Stand in blackjack (keep your current hand)",
                examples: ["stand"]
            },
            {
                icon: "fluent:battery-charge-24-regular",
                title: "Find Charger",
                description: "Tell Vector to go back to his charger",
                examples: ["go home", "go to your charger", "go charge", "recharge", "find your charger", "go to bed", "time to sleep"]
            },
            {
                icon: "fluent:cube-24-regular",
                title: "Roll Cube",
                description: "Make Vector play with and roll his cube",
                examples: ["roll your cube", "play with your cube", "cube roll", "show me a cube roll"]
            },
            {
                icon: "fluent:hand-right-24-regular",
                title: "Fist Bump",
                description: "Give Vector a fist bump",
                examples: ["fist bump", "high five", "give me a fist bump", "show me your fist"]
            },
            {
                icon: "fluent:vehicle-car-24-regular",
                title: "Do a Wheelie",
                description: "Make Vector do a wheelie",
                examples: ["do a wheelie", "wheelie", "stand up", "can you stand"]
            },
            {
                icon: "fluent:thumb-dislike-24-regular",
                title: "Scold Vector",
                description: "Let Vector know he did something wrong (he'll react!)",
                examples: ["bad robot", "shame on you", "that's not right", "you let me down", "behave"]
            },
            {
                icon: "fluent:thumb-like-24-regular",
                title: "Praise Vector",
                description: "Tell Vector he's doing a great job",
                examples: ["good job", "good boy", "thank you", "awesome", "excellent", "well done", "you're funny", "perfect", "wonderful"]
            },
            {
                icon: "fluent:camera-24-regular",
                title: "Take a Photo",
                description: "Ask Vector to take a picture",
                examples: ["take a photo", "take a picture", "take a selfie", "say cheese", "capture this moment"]
            },
            {
                icon: "fluent:cube-24-regular",
                title: "Find Cube",
                description: "Tell Vector to find his cube",
                examples: ["find your cube", "where's your cube", "look for your cube"]
            },
            {
                icon: "fluent:speaker-settings-24-regular",
                title: "Set Volume Level",
                description: "Set Vector's volume to a specific level",
                examples: ["set volume to 5", "set your volume to medium", "change volume to high"]
            },
            {
                icon: "fluent:stop-24-regular",
                title: "Stop/Cancel",
                description: "Tell Vector to stop what he's doing",
                examples: ["stop", "cancel", "quit", "I'm done", "stop what you're doing"]
            },
            {
                icon: "fluent:cube-24-regular",
                title: "Pick Up Cube",
                description: "Tell Vector to pick up his cube",
                examples: ["get a cube", "pick up your cube", "where's my cube", "show me a cube"]
            },
            {
                icon: "fluent:delete-24-regular",
                title: "Delete Items",
                description: "Delete timers, messages, or photos",
                examples: ["delete that"]
            }
        ];

function renderCategories(container, noResults, filteredList) {
    if (!container) return;
    container.innerHTML = '';
    
    if (filteredList.length === 0) {
        if (noResults) noResults.classList.add('show');
        return;
    }
    
    if (noResults) noResults.classList.remove('show');
    
    filteredList.forEach(command => {
        const card = document.createElement('div');
        card.className = 'category-card';
        const examplesHTML = command.examples.map(ex => `<span class="command-tag">"${ex}"</span>`).join('');
        
        card.innerHTML = `
            <div class="category-header">
                <iconify-icon icon="${command.icon}" class="category-icon"></iconify-icon>
                <div class="category-title">${command.title}</div>
            </div>
            <div class="category-description">${command.description}</div>
            <div class="commands-section"><div class="commands-label">Try saying:</div>
                <div class="command-examples">${examplesHTML}</div>
            </div>`;
        container.appendChild(card);
    });
}

function initVectorSearch() {
    const section = document.querySelector('#vector-voice-commands');
    if (!section) return;

    const searchInput = section.querySelector('#searchInput');
    const categoriesContainer = section.querySelector('#categoriesContainer');
    const noResults = section.querySelector('#noResults');
    const totalPhrasesEl = section.querySelector('#totalPhrases');

    if (!searchInput || !categoriesContainer) return;

    // Initial render
    renderCategories(categoriesContainer, noResults, VECTOR_COMMANDS);

    // Update stats
    if (totalPhrasesEl) {
        const total = VECTOR_COMMANDS.reduce((sum, cmd) => sum + cmd.examples.length, 0);
        totalPhrasesEl.textContent = total + '+';
    }

    // Search Logic - attaching directly to this instance's input
    searchInput.addEventListener('input', (e) => {
        const query = e.target.value.toLowerCase().trim();
        if (!query) {
            renderCategories(categoriesContainer, noResults, VECTOR_COMMANDS);
            return;
        }

        const filtered = VECTOR_COMMANDS.filter(cmd => 
            cmd.title.toLowerCase().includes(query) || 
            cmd.description.toLowerCase().includes(query) || 
            cmd.examples.some(ex => ex.toLowerCase().includes(query))
        );
        renderCategories(categoriesContainer, noResults, filtered);
    });
}

// Ensure it runs on both standard load and Shopify Editor changes
document.addEventListener('DOMContentLoaded', initVectorSearch);
document.addEventListener('shopify:section:load', initVectorSearch);
